export default "__VITE_ASSET__Bh7MP1pY__"